"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsAndIsotopesObject = void 0;
const elementsAndIsotopes_js_1 = require("./elementsAndIsotopes.js");
exports.elementsAndIsotopesObject = {};
for (const element of elementsAndIsotopes_js_1.elementsAndIsotopes) {
    exports.elementsAndIsotopesObject[element.symbol] = element;
}
//# sourceMappingURL=elementsAndIsotopesObject.js.map